var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2028_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.106 3.36238L6.106 3.36238C4.77452 3.67283 3.70297 4.7284 3.37562 6.05226C3.04764 7.37876 3.423 8.73202 4.38061 9.67109C4.70345 9.98772 4.89928 10.4992 4.89928 11.0404V11.1286C4.89928 11.4989 5.05747 11.8329 5.30944 12.0668V12.7692C5.30944 13.4753 5.88381 14.0497 6.58991 14.0497H7.41022C8.11631 14.0497 8.69069 13.4753 8.69069 12.7692V12.0668C8.94266 11.8329 9.10084 11.4989 9.10084 11.1286V11.0388C9.10084 10.507 9.30668 9.98495 9.6485 9.6424L9.61311 9.60709L9.64851 9.6424C10.3532 8.93612 10.7415 7.99742 10.7415 6.99967C10.7415 4.61393 8.53048 2.79727 6.106 3.36238ZM6.31497 4.25867L6.31497 4.25867C8.16113 3.82818 9.82116 5.20584 9.82116 6.99967C9.82116 7.75216 9.52853 8.45967 8.99702 8.99233C8.47742 9.51304 8.18053 10.2591 8.18053 11.0388V11.1286C8.18053 11.3271 8.01892 11.4887 7.82037 11.4887H6.17975C5.9812 11.4887 5.81959 11.3271 5.81959 11.1286V11.0404C5.81959 10.2496 5.53123 9.51048 5.02495 9.01401C4.3027 8.30573 4.01969 7.28159 4.269 6.27317C4.51398 5.28232 5.31724 4.49127 6.31497 4.25867ZM7.77037 12.7692C7.77037 12.9677 7.60876 13.1294 7.41022 13.1294H6.58991C6.39136 13.1294 6.22975 12.9677 6.22975 12.7692V12.409H7.77037V12.7692Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03424 2.68475L2.03424 2.68475C1.85454 2.50505 1.85454 2.2137 2.03424 2.034C2.21395 1.85429 2.50532 1.85429 2.685 2.034M2.03424 2.68475L3.84511 3.84483C4.02482 3.66513 4.02481 3.37379 3.84511 3.19408L2.685 2.034M2.03424 2.68475L3.19435 3.84483C3.19435 3.84484 3.19436 3.84484 3.19436 3.84484C3.37403 4.02454 3.66543 4.02454 3.84511 3.84484L2.03424 2.68475ZM2.685 2.034L2.64966 2.06933L2.685 2.034L2.685 2.034Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07812 6.53984H0.410156C0.156026 6.53984 -0.05 6.74587 -0.05 7C-0.05 7.25413 0.156026 7.46016 0.410156 7.46016H2.07812C2.33225 7.46016 2.53828 7.25413 2.53828 7C2.53828 6.74587 2.33225 6.53984 2.07812 6.53984Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 6.53984H11.9219C11.6677 6.53984 11.4617 6.74587 11.4617 7C11.4617 7.25413 11.6677 7.46016 11.9219 7.46016H13.5898C13.844 7.46016 14.05 7.25413 14.05 7C14.05 6.74587 13.844 6.53984 13.5898 6.53984Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.315 2.034L11.315 2.034C11.4947 1.8543 11.7861 1.85429 11.9657 2.034M11.315 2.034L10.8056 3.84484L11.9657 2.68475L11.9304 2.6494L11.9657 2.68475C12.1454 2.50507 12.1454 2.21371 11.9657 2.034M11.315 2.034L10.1549 3.19408C10.1548 3.19408 10.1548 3.19408 10.1548 3.19408C9.97514 3.37376 9.97514 3.66513 10.1548 3.84483L11.315 2.034ZM11.9657 2.034L11.9304 2.06934L11.9657 2.034C11.9657 2.034 11.9657 2.034 11.9657 2.034Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 -0.05C6.74587 -0.05 6.53984 0.156026 6.53984 0.410156V2.07812C6.53984 2.33225 6.74587 2.53828 7 2.53828C7.25413 2.53828 7.46016 2.33225 7.46016 2.07812V0.410156C7.46016 0.156026 7.25413 -0.05 7 -0.05Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2028_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHint);
export default __webpack_public_path__ + "static/media/hint.118c291f0196d514726f4e8a241126bd.svg";
export { ForwardRef as ReactComponent };